export const HOME = "/home";
export const CUSTOM_HOME = "/";

export const PUBLICATIONS = "/publications";
export const PUBLICATIONS_MATH = "/publications/math";
export const PUBLICATIONS_CODE = "/publications/code";

export const CONTACT = "/contact";
